import './ProductVendor.scss';

import { registryComponent } from '@boost-sd/components-registry/registry';
import type { ReactNodeRenderer } from '@components/CustomizableNode';
import CustomizableNode from '@components/CustomizableNode';
import { createClsNameMap } from '@utils';

export const clsNameMap = createClsNameMap()('product-vendor');

export type ProductVendorProps = {
  vendor: ReactNodeRenderer;
  color?: string;
  textTransform?: React.CSSProperties['textTransform'];
  fontSize?: number | string;
  fontFamily?: string;
  fontStyle?: string;
  textAlign?: React.CSSProperties['textAlign'];
  fontWeight?: number | string;
};

const ProductVendor = ({
  vendor,
  color,
  textTransform,
  fontSize,
  fontFamily,
  fontWeight,
  fontStyle,
  textAlign,
}: ProductVendorProps) => {
  const style: React.CSSProperties = {
    color,
    fontWeight,
    textTransform,
    fontSize,
    fontFamily,
    fontStyle,
    textAlign,
  };

  return (
    <div className={clsNameMap.root()} style={style}>
      <CustomizableNode
        renderer={
          textTransform === 'none' || typeof vendor !== 'string' ? vendor : vendor?.toLowerCase()
        }
      />
    </div>
  );
};

export default registryComponent('ProductVendor', ProductVendor);
